/**
 * Common types, enums, and base types for the Grass Production Planning and Management System (GPPMS)
 */
// ============================================
// ENUMS - Match DB enum naming
// ============================================
export var PaddockUseType;
(function (PaddockUseType) {
    PaddockUseType["ROTATIONAL_GRAZING"] = "ROTATIONAL_GRAZING";
    PaddockUseType["CONTINUOUS_GRAZING"] = "CONTINUOUS_GRAZING";
    PaddockUseType["CUT_AND_CARRY"] = "CUT_AND_CARRY";
    PaddockUseType["HAY"] = "HAY";
    PaddockUseType["SILAGE"] = "SILAGE";
    PaddockUseType["DEFERRED_STOCKPILING"] = "DEFERRED_STOCKPILING";
    PaddockUseType["MIXED"] = "MIXED";
})(PaddockUseType || (PaddockUseType = {}));
export var PaddockStatus;
(function (PaddockStatus) {
    PaddockStatus["ESTABLISHED"] = "ESTABLISHED";
    PaddockStatus["RENOVATION"] = "RENOVATION";
    PaddockStatus["DEGRADED"] = "DEGRADED";
    PaddockStatus["REST"] = "REST";
    PaddockStatus["DEFERRED"] = "DEFERRED";
    PaddockStatus["UNDER_RECOVERY"] = "UNDER_RECOVERY";
})(PaddockStatus || (PaddockStatus = {}));
export var OperationType;
(function (OperationType) {
    OperationType["GRAZING"] = "GRAZING";
    OperationType["CUTTING"] = "CUTTING";
    OperationType["MOWING"] = "MOWING";
    OperationType["FERTILIZATION"] = "FERTILIZATION";
    OperationType["LIMING"] = "LIMING";
    OperationType["IRRIGATION"] = "IRRIGATION";
    OperationType["WEED_CONTROL"] = "WEED_CONTROL";
    OperationType["PEST_CONTROL"] = "PEST_CONTROL";
    OperationType["RENOVATION"] = "RENOVATION";
    OperationType["SOIL_PREPARATION"] = "SOIL_PREPARATION";
})(OperationType || (OperationType = {}));
export var BiomassEstimationMethod;
(function (BiomassEstimationMethod) {
    BiomassEstimationMethod["HEIGHT_DENSITY_EQUATION"] = "HEIGHT_DENSITY_EQUATION";
    BiomassEstimationMethod["RISING_PLATE_METER"] = "RISING_PLATE_METER";
    BiomassEstimationMethod["VISUAL_ESTIMATE"] = "VISUAL_ESTIMATE";
    BiomassEstimationMethod["CUT_AND_WEIGH"] = "CUT_AND_WEIGH";
    BiomassEstimationMethod["NIRS_SENSOR"] = "NIRS_SENSOR";
    BiomassEstimationMethod["SATELLITE_NDVI"] = "SATELLITE_NDVI";
})(BiomassEstimationMethod || (BiomassEstimationMethod = {}));
// Note: DateRangeFilter and AuditInfo are exported from the root Common.ts
// They should be imported from "@packages/shared-types" directly
//# sourceMappingURL=Common.js.map